import { React, useState } from "react";
// import  useState  from "react";
import testing from "../../Images/testing.png";
import Explore1 from "../../Images/explore-1.png";
import Explore2 from "../../Images/explore-2.png";
import Explore3 from "../../Images/explore-3.png";
import Explore4 from "../../Images/explore-4.png";
import buttonImage from "../../Images/button-image.png";
// import SmallImg4 from "../../Images/woman-img-4.jpg";
// import DetailImage from "../../Images/woman-img-2.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function DetailFirstSec() {
  const [selectedImage, setSelectedImage] = useState(Explore1);
  const handleImageClick = (image) => {
    setSelectedImage(image);
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="row reverse-col">
            {/* <div className=" mx-2 res-top-mar"> */}
            <div className="col-md-3  "></div>
            <div className="col-md-2 col-xs-12 ">
              <div className="row ">
                <div className="col-md-12 col-3 col-sm-3 col-xs-3">
                  <div
                    className={` res-top-mar  ${
                      selectedImage === Explore1 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Explore1)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Explore1}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-12 col-3 mar-top col-sm-3 col-xs-3">
                  <div
                    className={`res-top-mar  ${
                      selectedImage === Explore2 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Explore2)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Explore2}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-12 col-3 mar-top col-sm-3 col-xs-3">
                  <div
                    className={` res-top-mar  ${
                      selectedImage === Explore3 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Explore3)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Explore3}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-12 col-3 mar-top col-sm-3 col-xs-3">
                  <div
                    className={` res-top-mar  ${
                      selectedImage === Explore4 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Explore4)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Explore4}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-xs-12 ">
              <LazyLoadImage
                effect="blur"
                className=" img-fluid"
                src={selectedImage}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="col-md-5 detail-margn-left">
          <div className="res-images">
            <div className="image-container">
              <h1 className="Cormorant-font fw-bold responsive-one-rem">
                Floral Maxi Dress
              </h1>
              <h5 className=" ">BLD24FT037-SML-MNT</h5>
              {/* <div className=" my-3">
                <button
                  type="button"
                  className="px-4 py-1 btn rounded-0   "
                  style={{ border: "1px solid black" }}
                >
                  <span className="me-2">
                    <LazyLoadImage effect="blur" src={buttonImage} alt="" />
                  </span>
                  <span>Size Chart</span>
                </button>
              </div> */}
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Fit type:</span>
                <span className=""> Regular fit</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Design details:</span>
                <span>
                  {" "}
                  Made in lightweight t-shirt fabric. Elasticated waistband,
                  wide leg cut.
                </span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Stretch:</span>
                <span> High</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Transparency: </span>
                <span> None</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Hand Feel:</span>
                <span> Regular</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Lining:</span>
                <span> None</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Material: </span>
                <span> 5 LYRA 95 COTTON</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Size:</span>
                <span> The model is165.1cm/5'5" and wears a size SMALL</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Occasion:</span>
                <span> Daily casual</span>
              </div>
              <div className="py-4 Cormorant-font  note-bg">
                <span className="fw-bold ">Note:</span>
                <span>
                  {" "}
                  The actual color of the product may vary slightly from the
                  image.
                </span>
              </div>
            </div>
            <div className="text-container">
              {/* col-md-3  col-xs-3 col-sm-3 */}
              {/* <div className="d-flex">
              <div   className={`mx-2 res-top-mar ${selectedImage === Explore1 ? "selected-image" : ""}`}>
                <LazyLoadImage
                effect="blur"
                  onClick={() => handleImageClick(Explore1)}
                  style={{ cursor: "pointer" }}
                  className="img-fluid"
                  src={Explore1}
                  alt=""
                />
              </div>
              <div className={`mx-2 res-top-mar ${selectedImage === Explore2 ? "selected-image" : ""}`}>
                <LazyLoadImage
                effect="blur"
                  onClick={() => handleImageClick(Explore2)}
                  style={{ cursor: "pointer" }}
                  className="img-fluid"
                  src={Explore2}
                  alt=""
                />
              </div>
              <div className={`mx-2 res-top-mar ${selectedImage === Explore3 ? "selected-image" : ""}`}>
                <LazyLoadImage
                effect="blur"
                  onClick={() => handleImageClick(Explore3)}
                  style={{ cursor: "pointer" }}
                  className="img-fluid"
                  src={Explore3}
                  alt=""
                />
              </div>
              <div className={`mx-2 res-top-mar ${selectedImage === Explore4 ? "selected-image" : ""}`}>
                <LazyLoadImage
                effect="blur"
                  onClick={() => handleImageClick(Explore4)}
                  style={{ cursor: "pointer" }}
                  className="img-fluid"
                  src={Explore4}
                  alt=""
                />
              </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailFirstSec;
